export default __webpack_public_path__ + "static/namakpara-312c59dcf04de99e371f0de001b0a774.png";